import axios from '../../axios';

export default async function consumeRequest(tempId: string): Promise<void> {
  const response = await axios.post<void>(
    `${process.env.REACT_APP_BASE_URL}/reward/consume`, undefined,
    {
      params: {
        tempId
      }
    }
  );
  return response.data;
}
